// src/components/steps/Confirm.jsx
import React, { useEffect } from "react";
import HorizontalTimeline from "../HorizontalTimeline";
import { default as content } from '../../content/en';
//import useScript from "../../util/useScript";
import config from "../../config/properties.json";

export default function Confirm({
  prev,
  userEmail,
  userSimType,
  userPlan,
  planPrice,
  customerSelections,
  setCustomerSelections,
  orderRef,
}) {

const next = () => {
  window.open("https://www.bikermobile.com/faqs", "_blank");
}

const pSim = customerSelections["Your Details"].stepDescription.includes("plastic");
const gettingStartedUrl = pSim ? "https://www.bikermobile.com/getting-started-plastic-sim" : "https://www.bikermobile.com/getting-started-esim";

/*TODO - we should probably refactor the following (e.g. pass order from the orderProcessing step and extract plan & price from the order)?*/
const planDescription = customerSelections["Select Plan"].stepDescription;
const openBracketLocation = planDescription.indexOf("(");
const closeBracketLocation = planDescription.indexOf(")");
const gtmPlanName = planDescription.substring(0,openBracketLocation-1);
const gtmPlanPrice = planDescription.substring(openBracketLocation+2,closeBracketLocation); //planPrice w/o pound sign

// console.log("planDescription: " + planDescription);
// console.log("openBracketLocation: " +  openBracketLocation);
// console.log("closeBracketLocation: " +  closeBracketLocation);
// console.log("gtmPlanName: " + gtmPlanName);
// console.log("gtmPlanPrice: " + gtmPlanPrice);

useEffect(() => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
      event: "subscription_signup",
      plan_name: gtmPlanName,
      plan_value: gtmPlanPrice,
      currency: "GBP",
      order_id: orderRef
  });
}, []);

  return (
    <>
     <HorizontalTimeline
                     customerSelections={customerSelections}
                     thisStep={Confirm.name} // Use the component name for the step
                   />
      <div className="card centered">
        <div className="step-header">
          <h2>{content.confirm.h2}</h2>
        </div>
        <div style={{ padding: 16 }}>
          <div className="confirm-info">
            <p>{content.confirm.orderRef} {orderRef}</p>
          </div>
          <div className="confirm-info">
            {!pSim && (
              <>
                <p>{content.confirm.eSimActivateViaSelfCare} <a className="confirm-link" href={config.webSelfCareUrl} target="_blank">{content.confirm.onlineSelfCareName}</a></p>
                <p>{content.confirm.eSimDownloadPrompt}</p>
              </>
            )}
            {pSim && (
              <>
                <p>{content.confirm.pSimDispatch}</p>
                <p>{content.confirm.pSimActivateViaSelfCare} <a className="confirm-link" href={config.webSelfCareUrl} target="_blank">{content.confirm.onlineSelfCareName}</a></p>
                <p>{content.confirm.pSimDownloadPrompt}</p>
              </>
            )}
            <div className="confirm-app-links">
              <a href="https://play.google.com/store/apps/details?id=com.tekmoni.bikermobile" target="_blank"><img src="/assets/Google_Play_Store_badge.png" alt="Google Play Store Badge" style={{ width: "145px", marginRight: "10px" }} /></a>
              <a href="https://apps.apple.com/us/app/biker-mobile/id6755542204" target="_blank"><img src="/assets/Apple_App_Store_badge.png" alt="Apple App Store Badge" style={{ width: "125px", marginRight: "10px" }} /></a>
            </div>
          </div>
          <div className="confirm-info">
            <p>
              {content.confirm.checkMailboxPrompt}
            </p>
          </div>
          <div className="confirm-info">
            <p>
              {content.confirm.gettingStartedMessage1} <a className="confirm-link" href={ gettingStartedUrl } target="_blank">{content.confirm.gettingStartedMessage2}</a> {content.confirm.gettingStartedMessage3} <a className="confirm-link" href="https://www.bikermobile.com/faqs" target="_blank">{content.confirm.gettingStartedMessage4}</a>.
            </p>
          </div>
          <div className="confirm-info">
            <p>{content.confirm.thankyou}</p>
          </div>
        </div>
      </div>
    </>
  );
}
